export default __webpack_public_path__ + "static/berge-meer_1_1_de-864d3f5ae416e71c5395789db6ae60c7.png";